import React, {useState, useEffect, useCallback} from 'react';
import { Row, SearchBarStyle } from '../../../../../styles/common';
import styled, { css } from 'styled-components';
import theme from '../../../../../styles/theme';

import { useGetItemHistSel, useGetItemSel, useSetItemRel } from '../../../../../interface/item';

import moment from 'moment';
import Button from '../../../../common/Button';
import FullModal from '../../../../common/modal/FullModal';
import AssetItem from '../AssetItem';

import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';


import { useGetStatusList } from '../../../../../interface/common';
import CommonDataGrid from '../../../../common/CommonDataGrid';
import { NumericFormat } from 'react-number-format';
import InoutItem from '../../inout/InoutItem';
import RelItem from './RelItem';


const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    
    div {
        color: ${theme.color.black};
        font-size: ${theme.fontSize.base};
    }
    transition: ${theme.windowSize.drawerTransition};

    .selected {
        background: ${theme.color.primary.pupple2};
    }
    .complete {
        background: ${theme.color.primary.pupple};
    }
`;

const TabText = styled.h3`
    display: inline-box;
    font-size: ${theme.fontSize.base};
    font-weight: 600;
    // width: calc(100% - 24px);
    margin: 0;
    ${(props)=> props.selected === true ? activeSpan : nonActiveSpan};
    transition : all 0.3s ease-in-out;
`
const activeSpan = css`
    color: ${theme.color.black[80]};
    border-bottom: 1px solid ${theme.color.black[80]};
`;
const nonActiveSpan = css`
    color: ${theme.color.black[40]};
`;

const NumericFormatCustom = (param) => {
    return (
        <NumericFormat
        type='text'
        displayType='text'
        thousandSeparator
        isNumericString
        prefix="₩ "
        value={param.row.pur_price}
      />
    )
}

const columns = [
    { field: 'cat_nm', headerName: '분류', width:100 },
    { field: 'lot_no', headerName: '표기번호', width:120 },
    { field: 'rel_info', headerName: '연계자산', width:300 },
    { field: 'tno', headerName: '자산번호', width:140 },
    { field: 'pcat_nm', headerName: '구분', width:100 },
    { field: 'maf_nm', headerName: '제조사', width:100 },
    { field: 'model_nm', headerName: '모델명', width:200 },
    { field: 'status_nm', headerName: '자산상태', width:100 },

    { field: 's_use_cnt30', headerName: '최근30일사용횟수', width:120 },
    { field: 's_use_cnt60', headerName: '최근60일사용횟수', width:120 },
    { field: 'location', headerName: '위치', width:120 },
    { field: 'model_sub', headerName: '모델유형', width:120 },
    { field: 'serial_no', headerName: '시리얼넘버', width:200 },
    { field: 'maf_date', headerName: '제조일자', width:100 },
    { field: 'pur_date', headerName: '구매일자', width:100 },
    { field: 'pur_tpnm', headerName: '구매구분', width:100 },
    { field: 'pur_price', headerName: '구매가격', width:120, renderCell:NumericFormatCustom},
    { field: 'uid1', headerName: '책임자', width:100 },
    { field: 'uid2', headerName: ' 부책임자', width:100 },
]

const histColumns = [
    { field: 'reg_dt', headerName: '일시', flex:1 },
    { field: 'mod_tpnm', headerName: '변경내용', flex:0.5 },
    { field: 'mod_stnm', headerName: '결과', flex:0.5 },
]

const ItemsRelMain = () => {

    const [sendParam,setSendParam] = useState();
    const [regOpen, setRegOpen] = useState(false);
    const [target, setTarget] = useState();

    const [cid, setCid] = useState(38);

    const [camera, setCamera] = useState();
    const [battery, setBattery] = useState();

    const [list, setList] = useState([]);
    const [bList, setBList] = useState([]);
    const [histList, setHistList] = useState([]);
    const [tab, setTab] = useState('INFO');

    const {data : statusList} = useGetStatusList();
    const {data, isLoading, refetch } = useGetItemSel(sendParam);
    const {data : itemHist, refetch: histRefetch} = useGetItemHistSel({});

    const { mutate } = useSetItemRel();

    const handleValueChange = (id, val) => {
        sendParam[id]=val;
    }

    useEffect(()=>{
        if(regOpen === false){
            histRefetch();
        }
    },[regOpen])

    useEffect(()=>{
        if(data){
            const temp = data.map((item,index)=>(
                {
                    ...item,
                    id:index,
                    maf_date: item.maf_date ? moment(item.maf_date).format('YYYY/MM/DD') : '',
                    pur_date: item.pur_date ? moment(item.pur_date).format('YYYY/MM/DD') : '',
                    rel_info: item.rid > 0 ? item.r_cat_nm + ' | ' + (item.r_tno ? item.r_tno : '-') + ' | ' + (item.r_lot_no ? item.r_lot_no : '-') : item.s_tid > 0 ? item.s_cat_nm + ' | ' + (item.s_tno ? item.s_tno : '-') + ' | ' + (item.s_lot_no ? item.s_lot_no : '-') : ''
                }
            ));
            setList(temp.filter(item=>item.cid === cid));
            setBList(temp.filter(item=>item.cid === 37));
        }else{
            setList([])
        }
    },[data, cid])

    useEffect(()=>{
        if(itemHist){
            setHistList(itemHist.map((item,index)=>({
                ...item,
                id:index,
                reg_dt: moment(item.reg_dt).format('YYYY/MM/DD HH:mm')})
                ));
        }else{
            setHistList([])
        }
    },[itemHist])

    const handleRelClick = useCallback((tid, rid, mod_st) => {
        // if(tid && tid > 0){
        //     if((mod_st && rid > 0) || mod_st === false){
                const temp = {
                    tid,
                    rid,
                    mod_st
                }
                mutate(
                    temp,
                    {
                        onSuccess:()=>{
                            setCamera();
                            setBattery();
                        }
                    }
                )
            // }
        // }else{
        //     alert('대상 자산을 선택해야 합니다.')
        // }
    })

    const selectCamera = (param) => {
        return camera && param.row.tid === camera.tid ? 'selected' : param.row.rid !== null && 'complete'
    }
    const selectBattery = (param) => {
        return battery && param.row.tid === battery.tid ? 'selected' : param.row.s_tid !== null && 'complete'
    }

    return (
        <MainWrap>
            <Row style={{display:'grid',gridTemplateColumns:'1fr 80px 1fr',gap: '16px'}}>
                <div>
                    <div style={{display:'flex',justifyContent:'space-between',height:'3rem'}}>
                        <FormControl style={{width:'10rem'}} size='small'>
                            <InputLabel id='cid-label'>대상장비분류</InputLabel>
                            <Select label="대상장비분류" labelId='cid-label' size='small' defaultValue={cid}>
                                <MenuItem value={38} onClick={()=>setCid(38)} >블랙박스</MenuItem>
                                <MenuItem value={40} onClick={()=>setCid(40)} >캠코더</MenuItem>
                            </Select>
                        </FormControl>
                        <div>
                            {(camera && camera.rid) && <Button style={{width:'10rem'}} onClick={()=>handleRelClick(camera.tid,'0',false)}>연계자산 제거</Button>}
                        </div>
                    </div>
                    <div style={{width:'100%', height: '85vh'}}>
                    <CommonDataGrid
                        isLoading={isLoading}
                        list={list}
                        columns={columns}
                        checkBox={false}
                        // showCount={100}
                        getRowClassName={selectCamera}
                        onRowClick={(e)=>{camera ? (e.row.tid !== camera.tid) ? setCamera(e.row) : setCamera() : setCamera(e.row);}}
                        />
                        </div>
                </div>
                <div>{!isLoading && <img src={'/images/ic_rel_plugs.svg'} style={{width:'80px',opacity:(camera && battery) ?1: 0.5}} onClick={()=>(camera && battery) && handleRelClick(camera.tid,battery.tid,true)}/>}</div>
                <div>
                    <div style={{display:'flex',justifyContent:'space-between',height:'3rem'}}>
                        <FormControl style={{width:'10rem'}} size='small'>
                            <InputLabel id='cid-label'>대상장비분류</InputLabel>
                            <Select label="대상장비분류" labelId='cid-label' size='small' defaultValue={'-'} disabled>
                                <MenuItem value={'-'} >배터리</MenuItem>
                            </Select>
                        </FormControl>
                        <div>
                            {(battery && battery.s_tid) && <Button style={{width:'10rem'}} onClick={()=>handleRelClick(battery.s_tid,'0',false)}>연계자산 제거</Button>}
                        </div>
                    </div>
                    <div style={{width:'100%', height: '85vh'}}>
                    <CommonDataGrid
                        isLoading={isLoading}
                        list={bList}
                        columns={columns}
                        checkBox={false}
                        // showCount={100}
                        getRowClassName={selectBattery}
                        onRowClick={(e)=>{battery ? (e.row.tid !== battery.tid) ? setBattery(e.row) : setBattery() : setBattery(e.row);}}
                        />
                        </div>
                </div>
            </Row>

            <FullModal open={regOpen}>
                <DetailWrap target={target} onClose={setRegOpen} />
            </FullModal>
        </MainWrap>
    )

}

const DetailWrapStyle = styled.div`
    width: 100%;
    height: 100%;
    // border: 1px solid red;
`;

const DetailWrap = ({target, onClose}) => {
    return (
        <DetailWrapStyle>
            <RelItem target={target} onClose={onClose}/>
        </DetailWrapStyle>
    )
}
export default ItemsRelMain;